export default "__VITE_ASSET__efeb7c5a__"